import { config } from '../../config/config';
import { EnabledChains } from '../../config/constants';
import post from './post';

type WithURL = {
    url?: string;
    chainId?: never;
};

type WithChainID = {
    url?: never;
    chainId?: EnabledChains[number];
};

type QueryParams = WithURL | WithChainID;

const orderBookQuery = async (path: string, body: Object, queryParams: QueryParams) => {
    let { chainId, url } = queryParams;

    if (!url && chainId) {
        url = config.endpoints[chainId].orderBook;
    }

    if (!url) {
        console.error('SubgraphQuery: URL is undefined');
        return;
    }

    const res = await post(`${url}${path}`, body);

    return res.order;
};

export default orderBookQuery;
